// Role display names, mirrored from cloud/role-management.js.
// The server stores the raw key; people need to read a name.
export const ROLE_LABELS = {
    MasterCalendar: 'Master Calendar',
    SuperintendentSeniorPastor: 'Superintendent / Senior Pastor',
    GeneralOverseer: 'General Overseer',
    Principal: 'Principal',
    JanitorialMaintenance: 'Janitorial & Maintenance',
    Security: 'Security',
    Landscaping: 'Landscaping',
    Tech: 'Tech',
    Finance: 'Finance',
    HR: 'Human Resources',
};

// Short forms for the approval rail, where horizontal room is scarce.
export const ROLE_SHORT_LABELS = {
    MasterCalendar: 'Calendar',
    SuperintendentSeniorPastor: 'Superintendent',
    GeneralOverseer: 'Overseer',
    Principal: 'Principal',
    JanitorialMaintenance: 'Janitorial',
    Security: 'Security',
    Landscaping: 'Landscaping',
    Tech: 'Tech',
    Finance: 'Finance',
    HR: 'HR',
};

// Access roles gate a section of the app (Finance, HR); they are not event
// approvers, so the approvals screen filters them out.
export const ACCESS_ROLE_KEYS = ['Finance', 'HR'];
export const isApprovalRole = (role) => !ACCESS_ROLE_KEYS.includes(role);

export const roleLabel = (role) => ROLE_LABELS[role] || role;
export const roleShortLabel = (role) => ROLE_SHORT_LABELS[role] || role;
